import React, { useEffect, useState, useRef } from "react";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import EmojiPicker from 'emoji-picker-react';
import { DatePicker, Input, Tooltip, message, Select as AntSelect } from "antd";
import Select from "react-select";
import moment from "moment";
// import { toast } from "react-toastify"; // Switched to antd message
import { FaUserEdit, FaBullhorn, FaPaperPlane, FaTrashAlt, FaPlus, FaPaperclip, FaFileAlt } from "react-icons/fa";
import { BsThreeDotsVertical, BsEmojiSmile } from "react-icons/bs";
import { MentionsInput, Mention } from 'react-mentions';
import axios from "axios";
import Skeleton from "react-loading-skeleton";
import { Fade } from "react-reveal";
import { Link } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";

import DataParser from "../../../utlits/Dataparser";
import CrmLeadsServices from "../../../Services/CrmLeadsServices";
import LeadPipelineService from "../../../Services/LeadPipelineService";
import UserProfile from "../../Reuseable/UserProfile..jsx";
import SocketService from "../../../Services/SocketService";
import LeadComments from "./LeadComments";
import LeadActivityLog from "./LeadActivityLog";
import UserServices from "../../../Services/UserService";

const { TextArea } = Input;
const { Option } = AntSelect;

const STAGE_CONFIG = {
    new: { label: "New", color: "#6366f1", bg: "#ede9fe" },
    contacted: { label: "Contacted", color: "#3b82f6", bg: "#dbeafe" },
    qualified: { label: "Qualified", color: "#f59e0b", bg: "#fef3c7" },
    proposal: { label: "Proposal", color: "#8b5cf6", bg: "#f3e8ff" },
    won: { label: "Won", color: "#10b981", bg: "#d1fae5" },
    lost: { label: "Lost", color: "#ef4444", bg: "#fee2e2" },
};

const LOST_REASONS = [
    { value: "price", label: "Price" },
    { value: "competitor", label: "Competitor" },
    { value: "timing", label: "Timing" },
    { value: "no_response", label: "No Response" },
    { value: "other", label: "Other" },
];

const CreateCrmLead = ({ editId, onSuccess, onCancel, canEditLead }) => {
    const [isEditable, setIsEditable] = useState(canEditLead !== false && !editId);
    const [rightTab, setRightTab] = useState("activity"); // "activity" | "notes"

    // Global message config to ensure alerts appear on top of modals
    useEffect(() => {
        message.config({
            top: 50,
            duration: 3,
            maxCount: 3,
            rtl: false,
            zIndex: 1000000001, // Higher than any modal
            getContainer: () => document.body,
        });
    }, []);
    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            border: state.isFocused ? "1px solid #0DDFAB" : "1px solid #eee",
            borderRadius: "10px",
            minHeight: "40px",
            boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(13, 223, 171, 0.25)" : "none",
            fontSize: "14px",
            backgroundColor: !isEditable ? "#f8f9fa" : "white",
            "&:hover": {
                border: state.isFocused ? "1px solid #0DDFAB" : "1px solid #eee",
            },
        }),
        valueContainer: (provided) => ({
            ...provided,
            padding: "0 15px",
            height: "40px",
            display: "flex",
            alignItems: "center",
        }),
        input: (provided) => ({
            ...provided,
            margin: "0px",
            padding: "0px",
            caretColor: "black",
            color: "black",
            boxShadow: "none !important",
            outline: "none !important",
            border: "none !important",
            background: "transparent",
            "& input": {
                boxShadow: "none !important",
                outline: "none !important",
                border: "none !important",
                caretColor: "black !important",
            },
        }),
        singleValue: (provided) => ({
            ...provided,
            margin: "0px",
            position: "absolute",
            top: "50%",
            transform: "translateY(-50%)",
        }),
        indicatorsContainer: (provided) => ({
            ...provided,
            height: "40px",
        }),
        indicatorSeparator: () => ({
            display: "none",
        }),
        placeholder: (provided) => ({
            ...provided,
            color: "#6c757d",
            position: "absolute",
            top: "50%",
            transform: "translateY(-50%)",
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected
                ? "#0DDFAB"
                : state.isFocused
                    ? "rgba(13, 223, 171, 0.1)"
                    : "transparent",
            color: state.isSelected ? "white" : "black",
            cursor: "pointer",
            "&:active": {
                backgroundColor: "#0DDFAB",
            },
        }),
    };

    const [isLoading, setIsLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [initialData, setInitialData] = useState({ sources: [], users: [], statuses: [], relatedTo: [], amountRanges: [] });
    const [statuses, setStatuses] = useState([]);
    const [mentionUsers, setMentionUsers] = useState([]);
    const [localNotes, setLocalNotes] = useState([]);
    const [editNoteId, setEditNoteId] = useState(null);
    const [UpdatedNote, setUpdatedNote] = useState("");
    const [creatorName, setCreatorName] = useState("");

    // UI Menu States
    const [isOwnerMenuOpen, setIsOwnerMenuOpen] = useState(false);
    const [isSourceMenuOpen, setIsSourceMenuOpen] = useState(false);
    const [isTypeMenuOpen, setIsTypeMenuOpen] = useState(false);
    const [isStageMenuOpen, setIsStageMenuOpen] = useState(false);
    const [isInterestMenuOpen, setIsInterestMenuOpen] = useState(false);
    const [ownerSearchTerm, setOwnerSearchTerm] = useState('');
    const [isDescFocused, setIsDescFocused] = useState(false);
    const [showEmojiPicker, setShowEmojiPicker] = useState(false);
    const [showLinkInput, setShowLinkInput] = useState(false);
    const [linkUrl, setLinkUrl] = useState("");
    const quillRef = useRef(null);
    const clickedLinkRef = useRef({ index: null, length: null });

    // Form States
    const [title, setTitle] = useState("");
    const [details, setDetails] = useState("");
    const [leadOwner, setLeadOwner] = useState(editId ? null : DataParser.UserId());
    const [leadSource, setLeadSource] = useState(null);
    const [leadStatus, setLeadStatus] = useState("Open");
    const [departmentId, setDepartmentId] = useState(null);
    const [prospectAmount, setProspectAmount] = useState(null);
    const [contactName, setContactName] = useState("");
    const [contactEmail, setContactEmail] = useState("");
    const [contactPhone, setContactPhone] = useState("");
    const [dueDate, setDueDate] = useState(null);
    const [leadInterest, setLeadInterest] = useState(null);
    const [interestCatalog, setInterestCatalog] = useState([]);
    const [followUpHistory, setFollowUpHistory] = useState([]);
    const [leadStage, setLeadStage] = useState("new");
    const [stageTransitioning, setStageTransitioning] = useState(false);
    const [lostModal, setLostModal] = useState(false);
    const [lostReason, setLostReason] = useState(null);
    const [lostNotes, setLostNotes] = useState("");
    const [pendingStage, setPendingStage] = useState(null);
    const [wonModal, setWonModal] = useState(false);
    const [wonAmount, setWonAmount] = useState(null);
    const [wonReference, setWonReference] = useState("");
    const [newComment, setNewComment] = useState("");
    const [noteAttachment, setNoteAttachment] = useState(null);
    const [isUploding, setIsUploding] = useState(false);
    const [isCustomerLoading, setIsCustomerLoading] = useState(false);

    // Validation States
    const [errors, setErrors] = useState({});

    const companyId = DataParser.CompanyId();
    const currentUserId = DataParser.UserId();
    const notePath = process.env.REACT_APP_NOTES_PATH || "http://localhost:4000/public/uploads/notes/";
    const userPermissions = DataParser.CompanyUserPermissions();

    const fetchInitialData = () => {
        setIsLoading(true);
        Promise.all([
            CrmLeadsServices.getInitialData(companyId),
            LeadPipelineService.getInterestCatalog(companyId),
        ]).then(([dataRes, interestRes]) => {
            if (dataRes.Good) {
                setInitialData(dataRes.data || { sources: [], users: [], statuses: [], relatedTo: [], amountRanges: [] });
            }
            if (interestRes.Good) {
                setInterestCatalog(interestRes.data || []);
            }
        }).catch((err) => console.error("Error fetching initial data:", err))
            .finally(() => setIsLoading(false));
    };

    const fetchMentionUsers = () => {
        UserServices.getCrmLeadMentionUsers(companyId).then((res) => {
            if (res.Good && res.data && res.data.user) {
                const formatted = res.data.user.map(u => ({
                    id: u.id,
                    display: `${u.first_name || ""} ${u.last_name || ""}`.trim(),
                    image: u.image
                }));
                setMentionUsers(formatted);
            }
        });
    };



    const handleDeleteNote = async (noteId) => {
        try {
            const res = await CrmLeadsServices.deleteNote(noteId, companyId);
            if (res.Good) {
                setLocalNotes(prev => prev.filter(n => n.id !== noteId));
            }
        } catch (err) { console.error("Failed to delete note:", err); }
    };

    useEffect(() => {
        if (!companyId) return;
        fetchMentionUsers();
        if (editId) {
            // Keep shimmer until BOTH initial data AND lead details are ready
            setIsLoading(true);
            Promise.all([
                CrmLeadsServices.getInitialData(companyId),
                LeadPipelineService.getInterestCatalog(companyId),
                CrmLeadsServices.getLead(companyId, editId),
            ]).then(([dataRes, interestRes, leadsRes]) => {
                if (dataRes.Good) setInitialData(dataRes.data || { sources: [], users: [], statuses: [], relatedTo: [], amountRanges: [] });
                if (interestRes.Good) setInterestCatalog(interestRes.data || []);
                if (leadsRes.Good && leadsRes.data) {
                    const lead = leadsRes.data;
                    if (lead) {
                        setTitle(lead.title);
                        setDetails(lead.details);
                        setLeadOwner(lead.lead_owner);
                        setLeadSource(lead.lead_source);
                        setLeadStatus(lead.lead_status || "Open");
                        setDepartmentId(lead.department_id);
                        setProspectAmount(lead.prospect_amount);
                        setContactName(lead.contact_name);
                        setContactEmail(lead.contact_email);
                        setContactPhone(lead.contact_phone);
                        setDueDate(lead.due_date ? moment(lead.due_date) : null);
                        setLeadInterest(lead.interest || null);
                        setFollowUpHistory(lead.follow_up_history || []);
                        setLeadStage(lead.stage || "new");
                        const sortedNotes = (lead.lead_notes || []).sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
                        setLocalNotes(sortedNotes);
                        if (lead.creator_details) {
                            setCreatorName(`${lead.creator_details.first_name || ""} ${lead.creator_details.last_name || ""}`.trim());
                        } else { setCreatorName("System User"); }
                        const isAdmin = userPermissions && userPermissions.includes("admin");
                        const isOwner = String(lead.lead_owner) === String(currentUserId);
                        const isCreator = String(lead.created_by) === String(currentUserId);
                        if (canEditLead === false) { setIsEditable(false); }
                        else { setIsEditable(canEditLead === true || isAdmin || isOwner || isCreator); }
                    }
                }
            }).catch(err => console.error("Error loading lead modal:", err))
              .finally(() => setIsLoading(false));
        } else {
            // New lead — only need initial data
            fetchInitialData();
            setLeadOwner(DataParser.UserId());
        }
    }, [editId, companyId]);

    useEffect(() => {
        const handleNoteUpdate = (payload) => {
            if (Number(payload.company_id) !== Number(companyId)) return;

            if (payload.action === "add_note") {
                if (Number(payload.data.lead_id) === Number(editId)) {
                    setLocalNotes(prev => {
                        const realNote = payload.data.note || payload.data;
                        const noteId = realNote?.id;
                        // Already exists by real ID — skip (handles race between API replace + socket)
                        if (prev.some(n => !n.isOptimistic && String(n.id) === String(noteId))) return prev;
                        // Replace any remaining optimistic note instead of appending
                        const optimisticIdx = prev.findIndex(n => n.isOptimistic);
                        if (optimisticIdx !== -1) {
                            const updated = [...prev];
                            updated[optimisticIdx] = { ...realNote, isOptimistic: false };
                            return updated;
                        }
                        return [...prev, realNote];
                    });
                }
            } else if (payload.action === "update_note") {
                setLocalNotes(prev => prev.map(n => n.id === payload.data.id ? payload.data : n));
            } else if (payload.action === "delete_note") {
                setLocalNotes(prev => prev.filter(n => n.id !== payload.data.id));
            }
        };
        SocketService.on("lead_note_update", handleNoteUpdate);
        return () => SocketService.off("lead_note_update", handleNoteUpdate);
    }, [editId, companyId]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest('.lead-type-pill-container') && !event.target.closest('.type-dropdown-wrap')) setIsTypeMenuOpen(false);
            if (!event.target.closest('.lead-owner-pill-container') && !event.target.closest('.owner-dropdown-wrap')) { setIsOwnerMenuOpen(false); setOwnerSearchTerm(''); }
            if (!event.target.closest('.lead-source-pill-container') && !event.target.closest('.source-dropdown-wrap')) setIsSourceMenuOpen(false);
            if (!event.target.closest('.stage-dropdown-wrap')) setIsStageMenuOpen(false);
            if (!event.target.closest('.interest-dropdown-wrap')) setIsInterestMenuOpen(false);
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const toggleDropdown = (name) => {
        setIsOwnerMenuOpen(name === 'owner' ? !isOwnerMenuOpen : false);
        setIsSourceMenuOpen(name === 'source' ? !isSourceMenuOpen : false);
        setIsTypeMenuOpen(name === 'type' ? !isTypeMenuOpen : false);
        setIsStageMenuOpen(name === 'stage' ? !isStageMenuOpen : false);
        setIsInterestMenuOpen(name === 'interest' ? !isInterestMenuOpen : false);
        if (name !== 'owner') setOwnerSearchTerm('');
    };

    const handlePhoneLookup = async (value) => {
        const phone = value.replace(/[^0-9]/g, "").slice(0, 15);
        setContactPhone(phone);

        // Validation check for phone
        if (phone.length > 0 && !phone.startsWith("0")) {
            setErrors(prev => ({ ...prev, contactPhone: "Client number must start with 0" }));
        } else {
            setErrors(prev => {
                const newErrors = { ...prev };
                delete newErrors.contactPhone;
                return newErrors;
            });
        }

        if (phone.startsWith("0") && phone.length >= 10) {
            setIsCustomerLoading(true);
            try {
                let res = await CrmLeadsServices.lookupCustomer(companyId, phone);
                let isExists = res.exists || (res.data && res.data.exists);

                // Fallback: If not found and starts with 0, try searching without the leading zero
                if (!isExists && phone.startsWith("0") && phone.length > 1) {
                    const strippedPhone = phone.substring(1);
                    const fallbackRes = await CrmLeadsServices.lookupCustomer(companyId, strippedPhone);
                    if (fallbackRes.Good && (fallbackRes.exists || (fallbackRes.data && fallbackRes.data.exists))) {
                        res = fallbackRes;
                        isExists = true;
                    }
                }

                if (res.Good && isExists) {
                    const leadData = res.data?.lead || res.data?.prospect || res.data?.data || res.data;
                    if (leadData) {
                        const name = leadData.contact_name || leadData.name || leadData.contactName;
                        const email = leadData.contact_email || leadData.email || leadData.contactEmail;
                        if (name) {
                            setContactName(name);
                            setContactEmail(email || "");
                            message.info(`Found existing customer: ${name}`);
                        }
                    }
                }
            } catch (err) { console.error("Lookup error", err); }
            finally { setIsCustomerLoading(false); }
        }
    };

    const handleSubmit = async (e) => {
        e?.preventDefault();

        const newErrors = {};
        if (!title?.trim()) newErrors.title = true;
        if (!departmentId) newErrors.departmentId = true;
        if (!leadSource) newErrors.leadSource = true;
        if (!contactName) newErrors.contactName = true;
        if (!contactPhone) newErrors.contactPhone = "Client number is required";
        else if (!contactPhone.startsWith("0")) newErrors.contactPhone = "Client number must start with 0";

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            const missing = [];
            if (newErrors.title) missing.push("Title");
            if (newErrors.departmentId) missing.push("Lead Interest");
            if (newErrors.leadSource) missing.push("Lead Source");
            if (newErrors.contactName) missing.push("Contact Name");
            if (newErrors.contactPhone) missing.push(newErrors.contactPhone);
            return message.error(`Please fill in required fields: ${missing.join(", ")}`);
        }

        setIsSubmitting(true);
        const payload = {
            title, details,
            lead_owner: leadOwner ? Number(leadOwner) : Number(DataParser.UserId()),
            lead_source: leadSource,
            department_id: departmentId,
            prospect_amount: prospectAmount !== null && prospectAmount !== "" ? Number(prospectAmount) : null,
            contact_name: contactName,
            contact_email: contactEmail, contact_phone: contactPhone,
            interest: leadInterest || null,
            ...(editId && { due_date: dueDate ? moment(dueDate).toISOString() : null }),
            company_id: companyId,
            company_identifier: DataParser.CompanyIdentifier()
        };

        try {
            const res = editId ? await CrmLeadsServices.updateLead(editId, payload) : await CrmLeadsServices.createLead(payload);
            if (res.Good) { message.success(`Lead ${editId ? 'updated' : 'created'} successfully!`); onSuccess(); }
            else { message.error(res.data || "Something went wrong"); }
        } catch (error) { message.error("An error occurred"); }
        finally { setIsSubmitting(false); }
    };

    const handleStageTransition = (newStage) => {
        if (!newStage || newStage === leadStage) return;
        if (newStage === "lost") {
            setPendingStage("lost");
            setLostReason(null);
            setLostNotes("");
            setLostModal(true);
            return;
        }
        if (newStage === "won") {
            setPendingStage("won");
            setWonAmount(null);
            setWonReference("");
            setWonModal(true);
            return;
        }
        doTransition(newStage, {});
    };

    const doTransition = async (targetStage, extra = {}) => {
        setStageTransitioning(true);
        try {
            await LeadPipelineService.transitionStage(editId, {
                company_id: DataParser.CompanyId(),
                stage: targetStage,
                ...extra,
            });
            setLeadStage(targetStage);
            message.success(`Stage moved to ${STAGE_CONFIG[targetStage]?.label || targetStage}.`);
        } catch (err) {
            const msg = err?.response?.data?.data || err?.message || "Transition failed.";
            message.error(msg);
        } finally {
            setStageTransitioning(false);
        }
    };

    const handleLostConfirm = async () => {
        if (!lostReason) { message.warning("Please select a lost reason."); return; }
        setLostModal(false);
        await doTransition("lost", { lost_reason: lostReason, lost_notes: lostNotes });
        setPendingStage(null);
    };

    const handleWonConfirm = async () => {
        setWonModal(false);
        await doTransition("won", { won_amount: wonAmount, won_reference: wonReference });
        setPendingStage(null);
    };

    const getFileIcon = (ext) => {
        const e = (ext || "").toLowerCase();
        if (["png", "jpg", "jpeg", "webp", "gif"].includes(e)) return "image";
        if (e === "pdf") return "pdf";
        return "file";
    };

    if (!editId) {
        const descIsActive = isDescFocused || showLinkInput || showEmojiPicker;
        const descHasValue = details && details !== '<p><br></p>';
        return (
            <div
                onClick={e => e.stopPropagation()}
                style={{
                    background: '#fff', borderRadius: '24px',
                    boxShadow: '0 10px 40px rgba(0,0,0,0.12)',
                    width: '95%', maxWidth: '850px',
                    fontFamily: 'inherit', padding: '10px 18px 20px 18px',
                    position: 'relative'
                }}
            >
                <style>{`
                    /* ── Title float wrap ── */
                    .lc-title-float-wrap { position: relative; margin-bottom: 4px; }
                    .lc-title-float-wrap input {
                        border-radius: 12px !important;
                        height: 44px !important;
                        padding: 0 16px !important;
                        font-size: 17px !important;
                        font-weight: 500 !important;
                        border: 1.5px solid transparent !important;
                        outline: none !important;
                        box-shadow: none !important;
                        background: transparent !important;
                        width: 100%;
                        transition: border-color 0.2s ease !important;
                    }
                    .lc-title-float-wrap input::placeholder { color: #a0a0a0 !important; font-size: 17px !important; font-weight: 500 !important; }
                    .lc-title-float-wrap input:hover,
                    .lc-title-float-wrap input:focus { border-color: #1D1D1D !important; box-shadow: none !important; outline: none !important; }
                    .lc-title-float-wrap input.is-invalid { border-color: #ff4d4f !important; }
                    .lc-title-float-wrap label {
                        position: absolute;
                        left: 16px !important;
                        top: 50% !important;
                        transform: translateY(-50%);
                        font-size: 17px !important;
                        color: #999;
                        background: #fff;
                        padding: 0 4px;
                        pointer-events: none;
                        opacity: 0 !important;
                        transition: all 0.2s ease !important;
                    }
                    .lc-title-float-wrap input:focus ~ label {
                        top: 0 !important;
                        font-size: 12px !important;
                        opacity: 1 !important;
                        color: #000;
                        font-weight: 600;
                    }
                    .lc-title-float-wrap input:focus::placeholder { color: transparent !important; }

                    /* ── Description float wrap (exact mirror of task-desc-float-wrap) ── */
                    .lc-desc-float-wrap {
                        position: relative;
                        border-radius: 12px;
                        border: 1.5px solid transparent;
                        transition: all 0.2s ease;
                    }
                    .lc-desc-float-wrap:hover, .lc-desc-float-wrap.lc-focused { border-color: #1D1D1D !important; }
                    .lc-desc-float-wrap .lc-desc-icon {
                        position: absolute;
                        left: 16px;
                        top: 13px !important;
                        transform: none !important;
                        color: #a0a0a0;
                        transition: all 0.2s ease;
                        pointer-events: none;
                        z-index: 10;
                        opacity: 1;
                    }
                    .lc-desc-float-wrap label {
                        position: absolute;
                        left: 48px;
                        top: 12px !important;
                        transform: none !important;
                        font-size: 17px !important;
                        line-height: 20px !important;
                        color: #a0a0a0;
                        transition: all 0.2s ease !important;
                        pointer-events: none;
                        background: #fff !important;
                        padding: 0 5px;
                        z-index: 99 !important;
                        opacity: 1;
                    }
                    .lc-desc-float-wrap.lc-focused label,
                    .lc-desc-float-wrap.lc-has-value label {
                        top: 0 !important;
                        transform: translateY(-50%) !important;
                        left: 12px !important;
                        font-size: 12px !important;
                        opacity: 1 !important;
                        color: #1D1D1D !important;
                        background: #fff !important;
                        z-index: 99 !important;
                    }
                    .lc-desc-float-wrap.lc-has-value:not(.lc-focused) label {
                        opacity: 0 !important;
                        visibility: hidden !important;
                        pointer-events: none !important;
                    }
                    .lc-desc-float-wrap.lc-focused .lc-desc-icon,
                    .lc-desc-float-wrap.lc-has-value .lc-desc-icon {
                        opacity: 0 !important;
                    }

                    /* Quill editor inside lc-desc-float-wrap */
                    .lc-desc-float-wrap .ql-container.ql-snow { border: none !important; font-family: inherit !important; }
                    .lc-desc-float-wrap .ql-editor {
                        padding: 12px 16px 8px 48px !important;
                        min-height: 44px !important;
                        max-height: 200px !important;
                        overflow-y: auto !important;
                        font-size: 15px !important;
                        transition: all 0.2s ease;
                    }
                    .lc-desc-float-wrap.lc-focused .ql-editor,
                    .lc-desc-float-wrap.lc-has-value .ql-editor,
                    .lc-desc-float-wrap .ql-editor:not(.ql-blank) { padding-left: 16px !important; }
                    .lc-desc-float-wrap .ql-editor.ql-blank::before {
                        display: none !important;
                    }
                    .lc-desc-float-wrap .ql-snow .ql-stroke { display: none !important; }
                    .lc-desc-float-wrap .ql-snow .ql-fill { display: none !important; }

                    /* Desc toolbar */
                    .lc-desc-toolbar {
                        display: flex;
                        gap: 4px;
                        background: #F5F5F5;
                        padding: 4px 8px;
                        border-radius: 8px;
                        width: fit-content;
                        margin: 0 0 10px 16px;
                        opacity: 0;
                        visibility: hidden;
                        transition: all 0.2s ease;
                        border: none !important;
                    }
                    .lc-desc-float-wrap.lc-focused .lc-desc-toolbar { opacity: 1; visibility: visible; }
                    button.lc-toolbar-btn {
                        background: transparent !important;
                        border: none !important;
                        padding: 4px !important;
                        border-radius: 4px !important;
                        color: #1D1D1D !important;
                        font-size: 20px !important;
                        display: flex !important;
                        align-items: center !important;
                        justify-content: center !important;
                        transition: all 0.2s ease !important;
                        cursor: pointer !important;
                        width: 36px !important;
                        height: 36px !important;
                        min-width: 36px !important;
                        min-height: 36px !important;
                        flex-shrink: 0 !important;
                        box-sizing: border-box !important;
                    }
                    button.lc-toolbar-btn i { display: inline !important; visibility: visible !important; color: #1D1D1D !important; font-size: 20px !important; line-height: 1 !important; }
                    button.lc-toolbar-btn:hover { background: #E8E8E8 !important; }

                    /* Link popover */
                    .lc-link-popover {
                        background: #fff;
                        border: 1.5px solid #1D1D1D;
                        border-radius: 10px;
                        padding: 4px;
                        bottom: 50px !important;
                        left: 10px !important;
                        width: 320px;
                        box-shadow: 0 10px 25px rgba(0,0,0,0.1);
                    }
                    .lc-link-popover input { border: none !important; box-shadow: none !important; outline: none !important; font-size: 14px !important; padding: 8px 12px !important; }
                    .lc-link-popover input:focus { border: none !important; border-color: transparent !important; box-shadow: none !important; outline: none !important; }
                    .lc-link-apply-btn {
                        background-color: #0DDFAB !important;
                        border: none !important;
                        color: #000 !important;
                        font-weight: 600 !important;
                        border-radius: 8px !important;
                        padding: 6px 16px !important;
                        font-size: 13px !important;
                    }

                    /* ── Action pill buttons ── */
                    .lc-action-btn {
                        display: flex;
                        align-items: center;
                        gap: 6px;
                        padding: 4px 8px;
                        border: 1px solid #E8E8E8;
                        border-radius: 5px;
                        background: #fff;
                        transition: all 0.2s ease;
                        min-width: fit-content;
                        height: 30px;
                        cursor: pointer;
                        white-space: nowrap;
                        color: #A0A0A0;
                    }
                    .lc-action-btn:hover, .lc-action-btn.lc-active { color: #1D1D1D; border-color: #1D1D1D; }
                    .lc-action-btn.error-border { border-color: #ff4d4f !important; }
                    .lc-action-icon { font-size: 16px; display: flex; align-items: center; }

                    /* ── Dropdown menus ── */
                    .lc-dropdown {
                        position: absolute;
                        top: calc(100% + 5px);
                        left: 0;
                        min-width: 180px;
                        background: #fff;
                        border: 1px solid #E8E8E8;
                        border-radius: 10px;
                        box-shadow: 0 10px 30px rgba(0,0,0,0.1);
                        z-index: 10001;
                        overflow: hidden;
                    }
                    .lc-dropdown-scroll { padding: 5px; max-height: 220px; overflow-y: auto; }
                    .lc-option {
                        display: flex;
                        align-items: center;
                        padding: 8px 10px;
                        border-radius: 6px;
                        cursor: pointer;
                        font-size: 13px;
                        font-weight: 500;
                        color: #1a1a1a;
                        gap: 8px;
                        transition: background 0.15s;
                    }
                    .lc-option:hover { background: #F5F5F5; }
                    .lc-user-dropdown {
                        position: absolute;
                        top: calc(100% + 5px);
                        left: 0;
                        width: 240px;
                        background: #fff;
                        border: 1px solid #E8E8E8;
                        border-radius: 10px;
                        box-shadow: 0 10px 30px rgba(0,0,0,0.1);
                        z-index: 10001;
                        overflow: hidden;
                    }
                    .lc-search-header {
                        padding: 12px 16px;
                        border-bottom: 1px solid #F0F0F0;
                        display: flex;
                        align-items: center;
                        gap: 12px;
                    }
                    .lc-search-header i { font-size: 18px; color: #1a1a1a; }
                    .lc-search-header input {
                        border: none !important;
                        outline: none !important;
                        box-shadow: none !important;
                        font-size: 14px;
                        width: 100%;
                        color: #1D1D1D;
                    }
                    .lc-user-scroll { padding: 5px; max-height: 200px; overflow-y: auto; }
                    .lc-user-option {
                        display: flex;
                        align-items: center;
                        gap: 10px;
                        padding: 8px 10px;
                        border-radius: 6px;
                        cursor: pointer;
                        font-size: 14px;
                        color: #1a1a1a;
                        transition: background 0.15s;
                    }
                    .lc-user-option:hover { background: #F5F5F5; }
                    .lc-avatar {
                        width: 28px;
                        height: 28px;
                        background: #0DDFAB;
                        color: #fff;
                        border-radius: 6px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 11px;
                        font-weight: 700;
                        flex-shrink: 0;
                    }

                    /* Hide number spinner on Amount field */
                    #lcAmount::-webkit-outer-spin-button,
                    #lcAmount::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0; }
                    #lcAmount { -moz-appearance: textfield; }

                    /* ── Create button ── */
                    .btn-create-lead {
                        background: #0DDFAB;
                        border: none;
                        border-radius: 5px;
                        height: 30px;
                        padding: 0 20px;
                        color: #fff;
                        font-weight: 700;
                        font-size: 13px;
                        display: flex;
                        align-items: center;
                        gap: 6px;
                        cursor: pointer;
                        transition: all 0.2s;
                    }
                    .btn-create-lead:hover { background: #0bc698; transform: translateY(-1px); }
                    .btn-create-lead:disabled { opacity: 0.6; cursor: not-allowed; transform: none; }
                `}</style>

                {/* Close button — same as task modal header */}
                <div className="d-flex justify-content-end pb-2" style={{ paddingBottom: '8px' }}>
                    <button
                        type="button"
                        className="btn-close"
                        onClick={onCancel}
                        style={{ fontSize: '18px', backgroundSize: '16px', opacity: 0.8 }}
                    />
                </div>

                {/* Modal body content — px-4 pb-4 pt-0 matching task modal */}
                <div style={{ padding: '0 24px 6px' }}>

                    {/* Title — floating label */}
                    <div className="lc-title-float-wrap mb-2">
                        <input
                            type="text"
                            id="lcTitleInput"
                            className={errors.title ? 'is-invalid' : ''}
                            placeholder="Enter a lead title"
                            value={title}
                            onChange={e => { setTitle(e.target.value); if (e.target.value.trim()) setErrors(prev => { const err = { ...prev }; delete err.title; return err; }); }}
                        />
                        <label htmlFor="lcTitleInput">Enter a lead title</label>
                    </div>

                    {/* Description — ReactQuill with floating label, exact same as task modal */}
                    <div
                        className={`lc-desc-float-wrap mb-3 ${descIsActive ? 'lc-focused' : ''} ${descHasValue ? 'lc-has-value' : ''}`}
                        onClick={(e) => {
                            const anchor = e.target.closest('a');
                            if (anchor && anchor.closest('.ql-editor')) {
                                e.preventDefault();
                                const url = anchor.getAttribute('href');
                                setLinkUrl(url);
                                setShowLinkInput(true);

                                const q = quillRef.current?.getEditor();
                                const Quill = ReactQuill.Quill;
                                const blot = Quill.find(anchor);
                                if (blot) {
                                    clickedLinkRef.current = {
                                        index: q.getIndex(blot),
                                        length: blot.length()
                                    };
                                }
                            }
                        }}
                    >
                        <ReactQuill
                            ref={quillRef}
                            theme="snow"
                            placeholder=""
                            value={details}
                            onChange={setDetails}
                            onFocus={() => setIsDescFocused(true)}
                            onBlur={() => setIsDescFocused(false)}
                            modules={{ toolbar: false }}
                            style={{ fontSize: '15px' }}
                        />
                        <span className="lc-desc-icon" style={{ display:'inline-block', width:'18px', height:'18px', flexShrink:0, backgroundColor: '#a0a0a0', mask:"url('/assets/images/descriptionmodal.svg') no-repeat center / contain", WebkitMask:"url('/assets/images/descriptionmodal.svg') no-repeat center / contain" }} />
                        <label>Description</label>

                        {/* Toolbar — same as task modal */}
                        <div className="lc-desc-toolbar" onMouseDown={e => e.preventDefault()}>
                            <button type="button" className="lc-toolbar-btn" onClick={() => { const q = quillRef.current?.getEditor(); if (q) { const f = q.getFormat(); q.format('bold', !f.bold); } }}>
                                <i className="uil uil-bold" />
                            </button>
                            <button type="button" className="lc-toolbar-btn" onClick={() => { const q = quillRef.current?.getEditor(); if (q) { const f = q.getFormat(); q.format('italic', !f.italic); } }}>
                                <i className="uil uil-italic" />
                            </button>
                            <button type="button" className="lc-toolbar-btn" onClick={() => { const q = quillRef.current?.getEditor(); if (q) { const f = q.getFormat(); q.format('underline', !f.underline); } }}>
                                <i className="uil uil-underline" />
                            </button>
                            <div className="position-relative">
                                <button type="button" className="lc-toolbar-btn" onClick={() => setShowEmojiPicker(v => !v)}>
                                    <i className="uil uil-smile" />
                                </button>
                                {showEmojiPicker && (
                                    <div className="position-absolute" style={{ top: '40px', left: '0', zIndex: 10000 }} onMouseDown={e => e.stopPropagation()}>
                                        <EmojiPicker onEmojiClick={emojiData => {
                                            const q = quillRef.current?.getEditor();
                                            if (q) {
                                                const range = q.getSelection();
                                                if (range) {
                                                    q.insertText(range.index, emojiData.emoji);
                                                } else {
                                                    q.insertText(q.getLength(), emojiData.emoji);
                                                }
                                            }
                                            setShowEmojiPicker(false);
                                        }} width={300} height={400} />
                                    </div>
                                )}
                            </div>
                            <div className="position-relative">
                                <button type="button" className="lc-toolbar-btn" onClick={() => {
                                    const q = quillRef.current?.getEditor();
                                    if (q) {
                                        const f = q.getFormat();
                                        if (f.link) {
                                            setLinkUrl(f.link);
                                            const range = q.getSelection();
                                            if (range) {
                                                const [leaf] = q.getLeaf(range.index);
                                                let blot = leaf;
                                                const Quill = ReactQuill.Quill;
                                                while (blot && blot.statics.blotName !== 'link' && blot !== q.scroll) {
                                                    blot = blot.parent;
                                                }
                                                if (blot && blot.statics.blotName === 'link') {
                                                    clickedLinkRef.current = {
                                                        index: q.getIndex(blot),
                                                        length: blot.length()
                                                    };
                                                } else {
                                                    clickedLinkRef.current = { index: null, length: null };
                                                }
                                            }
                                        } else {
                                            setLinkUrl("");
                                            clickedLinkRef.current = { index: null, length: null };
                                        }
                                    }
                                    setShowLinkInput(v => !v);
                                }}>
                                    <i className="uil uil-link" />
                                </button>
                                {showLinkInput && (
                                    <div className="position-absolute lc-link-popover" onMouseDown={e => e.stopPropagation()}>
                                        <div className="d-flex gap-2 align-items-center">
                                            <input type="text" className="form-control" placeholder="Paste or type a link..." value={linkUrl} onChange={e => setLinkUrl(e.target.value)}
                                                onKeyDown={e => {
                                                    if (e.key === 'Enter') {
                                                        const q = quillRef.current?.getEditor();
                                                        if (q) {
                                                            const { index, length } = clickedLinkRef.current;
                                                            if (index !== null && length !== null) {
                                                                q.formatText(index, length, 'link', linkUrl);
                                                            } else {
                                                                q.format('link', linkUrl);
                                                            }
                                                        }
                                                        setShowLinkInput(false);
                                                        setLinkUrl('');
                                                        clickedLinkRef.current = { index: null, length: null };
                                                    }
                                                }} />
                                            {linkUrl && (
                                                <a
                                                    href={linkUrl.startsWith('http') ? linkUrl : `https://${linkUrl}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="lc-toolbar-btn d-flex align-items-center justify-content-center"
                                                    style={{ padding: '4px 8px', borderRadius: '6px', border: '1.5px solid #1D1D1D', color: '#1D1D1D', textDecoration: 'none', background: '#fff', width: '32px', height: '32px' }}
                                                    title="Open link in new tab"
                                                >
                                                    <i className="uil uil-external-link-alt" style={{ fontSize: '18px' }} />
                                                </a>
                                            )}
                                            {linkUrl && (
                                                <button
                                                    type="button"
                                                    className="lc-toolbar-btn d-flex align-items-center justify-content-center"
                                                    style={{ padding: '4px 8px', borderRadius: '6px', border: '1.5px solid #ff4d4f', color: '#ff4d4f', background: '#fff', width: '32px', height: '32px' }}
                                                    title="Remove link"
                                                    onClick={() => {
                                                        const q = quillRef.current?.getEditor();
                                                        if (q) {
                                                            const { index, length } = clickedLinkRef.current;
                                                            if (index !== null && length !== null) {
                                                                q.formatText(index, length, 'link', false);
                                                            } else {
                                                                q.format('link', false);
                                                            }
                                                        }
                                                        setShowLinkInput(false);
                                                        setLinkUrl("");
                                                        clickedLinkRef.current = { index: null, length: null };
                                                    }}
                                                >
                                                    <i className="uil uil-link-broken" style={{ fontSize: '18px' }} />
                                                </button>
                                            )}
                                            <button type="button" className="lc-link-apply-btn" onClick={() => {
                                                const q = quillRef.current?.getEditor();
                                                if (q) {
                                                    const { index, length } = clickedLinkRef.current;
                                                    if (index !== null && length !== null) {
                                                        q.formatText(index, length, 'link', linkUrl);
                                                    } else {
                                                        q.format('link', linkUrl);
                                                    }
                                                }
                                                setShowLinkInput(false);
                                                setLinkUrl('');
                                                clickedLinkRef.current = { index: null, length: null };
                                            }}>Apply</button>
                                        </div>
                                    </div>
                                )}
                            </div>
                            <button type="button" className="lc-toolbar-btn" onClick={() => { const q = quillRef.current?.getEditor(); if (q) { const f = q.getFormat(); q.format('list', f.list === 'bullet' ? false : 'bullet'); } }}>
                                <i className="uil uil-list-ul" />
                            </button>
                        </div>
                    </div>

                    {/* Client Number + Client Name + Amount — float-label inputs, side by side */}
                    <div className="d-flex gap-2 mb-3">
                        <div className="float-input-wrap" style={{ flex: 1 }}>
                            <input
                                type="text"
                                id="lcClientNumber"
                                className={errors.contactPhone ? 'is-invalid' : ''}
                                placeholder=" "
                                value={contactPhone}
                                onChange={e => { handlePhoneLookup(e.target.value); if (e.target.value) setErrors(prev => { const err = { ...prev }; delete err.contactPhone; return err; }); }}
                            />
                            <label htmlFor="lcClientNumber" style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                Client Number *
                                {isCustomerLoading && <i className="uil uil-sync uil-spin" style={{ fontSize: '12px', color: '#0DDFAB' }} />}
                            </label>
                        </div>
                        <div className="float-input-wrap" style={{ flex: 1 }}>
                            <input
                                type="text"
                                id="lcClientName"
                                className={errors.contactName ? 'is-invalid' : ''}
                                placeholder=" "
                                value={contactName}
                                onChange={e => { setContactName(e.target.value); if (e.target.value) setErrors(prev => { const err = { ...prev }; delete err.contactName; return err; }); }}
                            />
                            <label htmlFor="lcClientName">Client Name *</label>
                        </div>
                        <div className="float-input-wrap" style={{ flex: 1 }}>
                            <input
                                type="number"
                                id="lcAmount"
                                placeholder=" "
                                value={prospectAmount || ''}
                                onChange={e => setProspectAmount(e.target.value ? Number(e.target.value) : null)}
                                style={{ MozAppearance: 'textfield' }}
                            />
                            <label htmlFor="lcAmount">Amount</label>
                        </div>
                    </div>

                    {/* Action Pills — Lead Type, Owner, Source, Amount */}
                    <div className="d-flex flex-wrap gap-1 align-items-center mb-4">

                        {/* Lead Type */}
                        <div className="lead-type-pill-container position-relative">
                            <Tooltip title="Lead Interest" placement="top">
                                <div
                                    className={`lc-action-btn${departmentId || isTypeMenuOpen ? ' lc-active' : ''}${errors.departmentId ? ' error-border' : ''}`}
                                    onClick={() => toggleDropdown('type')}
                                >
                                    <i className="uil uil-briefcase lc-action-icon" />
                                    <span style={{ fontSize: '13px', fontWeight: '600' }}>
                                        {initialData.relatedTo?.find(d => String(d.id || d._id) === String(departmentId))?.name || 'Lead Interest'}
                                    </span>
                                </div>
                            </Tooltip>
                            {isTypeMenuOpen && (
                                <div className="lc-dropdown">
                                    <div className="lc-dropdown-scroll">
                                        {(initialData.relatedTo || []).map(d => (
                                            <div key={d.id || d._id} className="lc-option" onClick={() => { setDepartmentId(d.id || d._id); setErrors(prev => { const e = { ...prev }; delete e.departmentId; return e; }); setIsTypeMenuOpen(false); }}>
                                                {d.name}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Owner */}
                        <div className="lead-owner-pill-container position-relative">
                            <Tooltip title="Lead Owner" placement="top">
                                <div
                                    className={`lc-action-btn${leadOwner || isOwnerMenuOpen ? ' lc-active' : ''}`}
                                    onClick={() => toggleDropdown('owner')}
                                >
                                    <span style={{ display:'inline-block', width:'15px', height:'15px', flexShrink:0, backgroundColor: leadOwner ? '#1D1D1D' : '#A0A0A0', mask:"url('/assets/images/assignedtomodal.svg') no-repeat center / contain", WebkitMask:"url('/assets/images/assignedtomodal.svg') no-repeat center / contain" }} />
                                    <span style={{ fontSize: '13px', fontWeight: '600' }}>
                                        {(() => { const o = initialData.users?.find(u => String(u.id || u._id) === String(leadOwner)); return o ? `${o.first_name} ${o.last_name}` : 'Owner'; })()}
                                    </span>
                                </div>
                            </Tooltip>
                            {isOwnerMenuOpen && (
                                <div className="lc-user-dropdown">
                                    <div className="lc-search-header">
                                        <i className="uil uil-search" />
                                        <input autoFocus placeholder="Search owner..." value={ownerSearchTerm} onChange={e => setOwnerSearchTerm(e.target.value)} />
                                    </div>
                                    <div className="lc-user-scroll">
                                        {(initialData.users || []).filter(u => `${u.first_name} ${u.last_name}`.toLowerCase().includes(ownerSearchTerm.toLowerCase())).slice(0, 8).map(u => (
                                            <div key={u.id || u._id} className="lc-user-option" onClick={() => { setLeadOwner(u.id || u._id); setIsOwnerMenuOpen(false); setOwnerSearchTerm(''); }}>
                                                <div className="lc-avatar">{(u.first_name?.[0] || '').toUpperCase()}{(u.last_name?.[0] || '').toUpperCase()}</div>
                                                <span>{u.first_name} {u.last_name}</span>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Source */}
                        <div className="lead-source-pill-container position-relative">
                            <Tooltip title="Lead Source" placement="top">
                                <div
                                    className={`lc-action-btn${leadSource || isSourceMenuOpen ? ' lc-active' : ''}${errors.leadSource ? ' error-border' : ''}`}
                                    onClick={() => toggleDropdown('source')}
                                >
                                    <i className="uil uil-globe lc-action-icon" />
                                    <span style={{ fontSize: '13px', fontWeight: '600' }}>
                                        {initialData.sources?.find(s => String(s.id || s._id) === String(leadSource))?.name || 'Source'}
                                    </span>
                                </div>
                            </Tooltip>
                            {isSourceMenuOpen && (
                                <div className="lc-dropdown">
                                    <div className="lc-dropdown-scroll">
                                        {(initialData.sources || []).map(s => (
                                            <div key={s.id || s._id} className="lc-option" onClick={() => { setLeadSource(s.id || s._id); setErrors(prev => { const e = { ...prev }; delete e.leadSource; return e; }); setIsSourceMenuOpen(false); }}>
                                                {s.name}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>

                    </div>

                    {/* Footer */}
                    <div className="d-flex align-items-center justify-content-between pt-3">
                        <div /> {/* left side empty — no attachment for leads */}
                        <button className="btn-create-lead" onClick={handleSubmit} disabled={isSubmitting}>
                            {isSubmitting
                                ? <div className="spinner-border spinner-border-sm" role="status" />
                                : <i className="uil uil-plus" style={{ fontSize: '16px' }} />}
                            Create Lead
                        </button>
                    </div>

                </div>
            </div>
        );
    }

    const getStatusBadge = (stage) => {
        const s = STAGE_CONFIG[stage] || { bg: "#f1f5f9", color: "#475569", label: stage || "—" };
        return (
            <span style={{
                background: s.bg, color: s.color,
                padding: "4px 12px", borderRadius: "8px",
                fontSize: "13px", fontWeight: "600",
                whiteSpace: "nowrap", display: "inline-block",
            }}>{s.label}</span>
        );
    };

    const descIsActive = isDescFocused || showLinkInput || showEmojiPicker;
    const descHasValue = details && details !== '<p><br></p>';

    return (
        <>
            <style>{`
                .edit-task-container {
                    width: 95%; max-width: 1100px; height: 90vh;
                    background: #fff; border-radius: 24px; display: flex; overflow: hidden;
                    box-shadow: 0 20px 60px rgba(0,0,0,0.15); position: relative;
                }
                .edit-left-panel { flex: 0.65; display: flex; flex-direction: column; overflow: hidden; border-right: 1px solid #F0F0F0; }
                .edit-left-scroll { flex: 1; overflow-y: auto; padding: 15px 40px 16px 30px; }
                .edit-right-panel { flex: 0.35; display: flex; flex-direction: column; background: #fff; padding: 24px; }
                
                .task-title-float-wrap-edit { position: relative; margin-bottom: 12px; }
                .task-title-float-wrap-edit input {
                    border-radius: 12px !important; min-height: 44px !important; padding: 10px 0 !important;
                    font-size: 17px !important; font-weight: 500 !important; border: 1.5px solid transparent !important;
                    transition: all 0.2s ease !important; width: 100%; color: #1D1D1D; background: transparent !important;
                    margin-left: 0 !important;
                }
                .task-title-float-wrap-edit input:focus, .task-title-float-wrap-edit input:hover { border-color: #1D1D1D !important; padding-left: 16px !important; padding-right: 16px !important; outline: none !important; box-shadow: none !important; }
                .task-title-float-wrap-edit input::placeholder { color: #A0A0A0; font-weight: 400; opacity: 1; transition: opacity 0.2s; }
                .task-title-float-wrap-edit input:focus::placeholder { opacity: 0; }
                .task-title-float-wrap-edit label {
                    position: absolute; left: 16px !important; top: 50% !important; transform: translateY(-50%);
                    font-size: 15px !important; opacity: 0 !important; transition: all 0.2s ease !important;
                    pointer-events: none; color: #a0a0a0;
                }
                .task-title-float-wrap-edit input:focus ~ label {
                    top: 0 !important; transform: translateY(-50%); left: 12px !important;
                    font-size: 12px !important; opacity: 1 !important; background: #fff; padding: 0 4px; color: #1D1D1D;
                }

                .meta-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 0 30px; margin-bottom: 0; padding-right: 10px; }
                .meta-item { display: flex; align-items: center; gap: 12px; min-height: 26px; }
                .meta-label-wrap { display: flex; align-items: center; gap: 10px; width: 155px; white-space: nowrap; }
                .meta-label-icon { font-size: 18px; color: #A0A0A0; }
                .meta-label { font-size: 13px; color: #A0A0A0; font-weight: 500; }
                .meta-value { flex: 1; display: flex; align-items: center; position: relative; }
                
                .action-btn-wrap-edit { border: none; border-radius: 8px; padding: 2px 0; display: flex; align-items: center; gap: 6px; cursor: pointer; transition: all 0.2s ease; min-height: 26px; background: transparent; white-space: nowrap; width: 100%; }
                .user-badge-teal { background: #0DDFAB; color: #fff; width: 20px; height: 20px; border-radius: 4px; display: flex; align-items: center; justify-content: center; font-weight: 700; font-size: 9px; margin-right: 8px; }
                .user-name-text { font-size: 13px; font-weight: 400; color: #1D1D1D; }

                .custom-user-dropdown { position: absolute; top: 100%; left: 0; width: 250px; background: #fff; border: 1px solid #E8E8E8; border-radius: 10px; box-shadow: 0 10px 30px rgba(0,0,0,0.1); z-index: 10000; margin-top: 5px; overflow: hidden; }
                .search-header { padding: 12px 16px; border-bottom: 1px solid #F0F0F0; display: flex; align-items: center; gap: 12px; }
                .search-header i { font-size: 18px; color: #1a1a1a; }
                .search-header input { border: none !important; outline: none !important; box-shadow: none !important; font-size: 14px; width: 100%; color: #1D1D1D; background: transparent !important; }
                .user-list-scroll { padding: 5px; max-height: 250px; overflow-y: auto; }
                .user-option-item { display: flex; align-items: center; gap: 10px; padding: 8px 10px; border-radius: 6px; cursor: pointer; transition: all 0.2s ease; font-size: 11px; color: #1a1a1a; }
                .user-option-item:hover { background: #F5F5F5; }

                /* Description float wrap (exact same as Create Lead modal) */
                .lc-desc-float-wrap { position: relative; border-radius: 12px; border: 1.5px solid transparent; transition: all 0.2s ease; margin-top: 20px; }
                .lc-desc-float-wrap:hover, .lc-desc-float-wrap.lc-focused { border-color: #1D1D1D !important; background: #fff; }
                .lc-desc-float-wrap .lc-desc-icon { position: absolute; left: 16px; top: 13px !important; transform: none !important; color: #a0a0a0; transition: all 0.2s ease; pointer-events: none; z-index: 10; opacity: 1; }
                .lc-desc-float-wrap label { position: absolute; left: 48px; top: 12px !important; font-size: 17px !important; line-height: 20px !important; color: #a0a0a0; transition: all 0.2s ease !important; pointer-events: none; background: #fff !important; padding: 0 5px; z-index: 99 !important; transform: none !important; opacity: 1; }
                .lc-desc-float-wrap.lc-focused label,
                .lc-desc-float-wrap.lc-has-value label {
                    top: 0 !important;
                    transform: translateY(-50%) !important;
                    left: 12px !important;
                    font-size: 12px !important;
                    opacity: 1 !important;
                    color: #1D1D1D !important;
                    background: #fff !important;
                    z-index: 99 !important;
                }
                .lc-desc-float-wrap.lc-has-value:not(.lc-focused) label {
                    opacity: 0 !important;
                    visibility: hidden !important;
                    pointer-events: none !important;
                }
                .lc-desc-float-wrap.lc-focused .lc-desc-icon,
                .lc-desc-float-wrap.lc-has-value .lc-desc-icon { opacity: 0 !important; }
                .lc-desc-float-wrap .ql-container.ql-snow { border: none !important; font-family: inherit !important; }
                .lc-desc-float-wrap .ql-editor { padding: 12px 16px 8px 48px !important; min-height: 44px !important; max-height: 200px !important; overflow-y: auto !important; font-size: 15px !important; transition: all 0.2s ease; }
                .lc-desc-float-wrap.lc-focused .ql-editor, .lc-desc-float-wrap.lc-has-value .ql-editor, .lc-desc-float-wrap .ql-editor:not(.ql-blank) { padding-left: 16px !important; }
                .lc-desc-float-wrap .ql-editor.ql-blank::before {
                    display: none !important;
                }

                .lc-desc-toolbar { display: flex; gap: 4px; background: #F5F5F5; padding: 4px 8px; border-radius: 8px; width: fit-content; margin: 0 0 10px 16px; opacity: 0; visibility: hidden; transition: all 0.2s ease; border: none !important; }
                .lc-desc-float-wrap.lc-focused .lc-desc-toolbar { opacity: 1; visibility: visible; }
                button.lc-toolbar-btn { background: transparent !important; border: none !important; padding: 4px !important; border-radius: 4px !important; color: #1D1D1D !important; font-size: 20px !important; display: flex !important; align-items: center !important; justify-content: center !important; transition: all 0.2s ease !important; cursor: pointer !important; width: 36px !important; height: 36px !important; min-width: 36px !important; min-height: 36px !important; flex-shrink: 0 !important; box-sizing: border-box !important; }
                button.lc-toolbar-btn i { display: inline !important; visibility: visible !important; color: #1D1D1D !important; font-size: 20px !important; line-height: 1 !important; }
                button.lc-toolbar-btn:hover { background: #E8E8E8 !important; }
                .lc-link-popover { background: #fff; border: 1.5px solid #1D1D1D; border-radius: 10px; padding: 4px; bottom: 50px !important; left: 10px !important; width: 320px; box-shadow: 0 10px 25px rgba(0,0,0,0.1); z-index: 10002; }
                .lc-link-popover input { border: none !important; box-shadow: none !important; outline: none !important; font-size: 14px !important; padding: 8px 12px !important; }
                .lc-link-apply-btn { background-color: #0DDFAB !important; border: none !important; color: #000 !important; font-weight: 600 !important; border-radius: 8px !important; padding: 6px 16px !important; font-size: 13px !important; }

                .modal-close-icon-btn { position: absolute; top: 20px; right: 20px; background: transparent; border: none; font-size: 24px; color: #A0A0A0; cursor: pointer; z-index: 10010; padding: 5px; border-radius: 50%; display: flex; align-items: center; justify-content: center; }
                .modal-close-icon-btn:hover { color: #1D1D1D; background: #F8F8F8; }
                
                .section-header { font-size: 16px; font-weight: 700; color: #1D1D1D; margin: 25px 0 12px 0; }
                .btn-save-edit { background: #0DDFAB; color: #fff; border: none; padding: 8px 24px; border-radius: 8px; font-size: 14px; font-weight: 600; cursor: pointer; transition: all 0.2s; display: inline-flex; align-items: center; justify-content: center; }
                .btn-save-edit:hover { background: #0bc598; transform: translateY(-1px); }
            `}</style>

            <div className="edit-task-container" onClick={e => e.stopPropagation()}>
                    <button className="modal-close-icon-btn" onClick={onCancel}><i className="uil uil-times" /></button>

                    <div className="edit-left-panel">
                        <div className="edit-left-scroll">
                            {isLoading ? (
                                <div className="w-100 p-5"><Skeleton count={8} height={40} style={{ marginBottom: '15px' }} /></div>
                            ) : (
                                <>
                                    <div className="task-title-float-wrap-edit">
                                        <input type="text" placeholder="Enter a lead title" value={title} onChange={e => setTitle(e.target.value)} disabled={!isEditable} />
                                        <label>Enter a lead title</label>
                                    </div>

                                    <div className="meta-grid">
                                        {/* Lead Owner */}
                                        <div className="meta-item owner-dropdown-wrap">
                                            <div className="meta-label-wrap"><span style={{ display:'inline-block', width:'16px', height:'16px', flexShrink:0, backgroundColor: '#A0A0A0', mask:"url('/assets/images/assignedtomodal.svg') no-repeat center / contain", WebkitMask:"url('/assets/images/assignedtomodal.svg') no-repeat center / contain", transform: 'translateZ(0)', WebkitTransform: 'translateZ(0)', imageRendering: '-webkit-optimize-contrast' }} /><span className="meta-label">Lead Owner:</span></div>
                                            <div className="meta-value">
                                                <div className="action-btn-wrap-edit" onClick={() => isEditable && toggleDropdown('owner')}>
                                                    {(() => {
                                                        const owner = initialData.users?.find(u => String(u.id || u._id) === String(leadOwner));
                                                        const name = owner ? `${owner.first_name} ${owner.last_name}` : "Select Owner";
                                                        const initials = name.split(" ").map(n => n[0]).join("").toUpperCase().slice(0, 2);
                                                        return <><div className="user-badge-teal">{initials}</div><span className="user-name-text">{name}</span></>;
                                                    })()}
                                                </div>
                                                {isOwnerMenuOpen && (
                                                    <div className="custom-user-dropdown">
                                                        <div className="search-header"><i className="uil uil-search" /><input autoFocus placeholder="Search..." value={ownerSearchTerm} onChange={e => setOwnerSearchTerm(e.target.value)} /></div>
                                                        <div className="user-list-scroll">
                                                            {initialData.users?.filter(u => `${u.first_name} ${u.last_name}`.toLowerCase().includes(ownerSearchTerm.toLowerCase())).map(u => (
                                                                <div key={u.id || u._id} className="user-option-item" onClick={() => { setLeadOwner(u.id || u._id); setIsOwnerMenuOpen(false); }}>
                                                                    <div className="user-badge-teal" style={{ width: 18, height: 18, fontSize: 8 }}>{(u.first_name?.[0] || '').toUpperCase()}</div>
                                                                    <span>{u.first_name} {u.last_name}</span>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        {/* Lead Source */}
                                        <div className="meta-item source-dropdown-wrap">
                                            <div className="meta-label-wrap"><i className="uil uil-globe meta-label-icon" /><span className="meta-label">Source:</span></div>
                                            <div className="meta-value">
                                                <div className="action-btn-wrap-edit" onClick={() => isEditable && toggleDropdown('source')}>
                                                    <span className="user-name-text">{initialData.sources?.find(s => String(s.id || s._id) === String(leadSource))?.name || "Select Source"}</span>
                                                </div>
                                                {isSourceMenuOpen && (
                                                    <div className="custom-user-dropdown" style={{ width: 250, left: 'auto', right: 0 }}>
                                                        <div className="user-list-scroll">
                                                            {initialData.sources?.map(s => (
                                                                <div key={s.id || s._id} className="user-option-item" onClick={() => { setLeadSource(s.id || s._id); setIsSourceMenuOpen(false); }}>{s.name}</div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        {/* Lead Type */}
                                        <div className="meta-item type-dropdown-wrap">
                                            <div className="meta-label-wrap"><i className="uil uil-briefcase meta-label-icon" /><span className="meta-label">Lead Interest:</span></div>
                                            <div className="meta-value">
                                                <div className="action-btn-wrap-edit" onClick={() => isEditable && toggleDropdown('type')}>
                                                    <span className="user-name-text">{initialData.relatedTo?.find(d => String(d.id || d._id) === String(departmentId))?.name || "Select Type"}</span>
                                                </div>
                                                {isTypeMenuOpen && (
                                                    <div className="custom-user-dropdown" style={{ width: 250 }}>
                                                        <div className="user-list-scroll">
                                                            {initialData.relatedTo?.map(d => (
                                                                <div key={d.id || d._id} className="user-option-item" onClick={() => { setDepartmentId(d.id || d._id); setIsTypeMenuOpen(false); }}>{d.name}</div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        {/* Lead Stage */}
                                        <div className="meta-item stage-dropdown-wrap">
                                            <div className="meta-label-wrap"><i className="uil uil-process meta-label-icon" /><span className="meta-label">Stage:</span></div>
                                            <div className="meta-value">
                                                <div className="action-btn-wrap-edit" onClick={() => isEditable && toggleDropdown('stage')}>
                                                    {getStatusBadge(leadStage)}
                                                </div>
                                                {isStageMenuOpen && (
                                                    <div className="custom-user-dropdown" style={{ width: 180, left: 'auto', right: 0 }}>
                                                        <div className="user-list-scroll">
                                                            {Object.entries(STAGE_CONFIG).map(([key, cfg]) => (
                                                                <div key={key} className="user-option-item" onClick={() => { handleStageTransition(key); setIsStageMenuOpen(false); }}>
                                                                    <span style={{ width: 8, height: 8, borderRadius: '50%', background: cfg.color }} />
                                                                    {cfg.label}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        {/* Due Date */}
                                        <div className="meta-item">
                                            <div className="meta-label-wrap"><span style={{ display:'inline-block', width:'16px', height:'16px', flexShrink:0, backgroundColor: '#A0A0A0', mask:"url('/assets/images/duedatemodal.svg') no-repeat center / contain", WebkitMask:"url('/assets/images/duedatemodal.svg') no-repeat center / contain", transform: 'translateZ(0)', WebkitTransform: 'translateZ(0)', imageRendering: '-webkit-optimize-contrast' }} /><span className="meta-label">Follow-up:</span></div>
                                            <div className="meta-value">
                                                <DatePicker bordered={false} suffixIcon={null} className={`p-0 ${dueDate ? 'has-value' : ''}`} value={dueDate} onChange={setDueDate} format="MMMM DD," disabled={!isEditable} style={{ fontSize: dueDate ? 15 : 12, width: dueDate ? '140px' : '110px' }} placeholder="Select Date" />
                                            </div>
                                        </div>
                                    </div>

                                    {/* Client Number + Client Name + Amount — side by side */}
                                    <div className="d-flex gap-2 mt-4">
                                        <div className={`float-input-wrap ${contactPhone ? 'has-value' : ''}`} style={{ flex: 1 }}>
                                            <input
                                                type="text"
                                                id="lcClientNumberEdit"
                                                className={errors.contactPhone ? 'is-invalid' : ''}
                                                placeholder=" "
                                                value={contactPhone}
                                                onChange={e => { handlePhoneLookup(e.target.value); if (e.target.value) setErrors(prev => { const err = { ...prev }; delete err.contactPhone; return err; }); }}
                                                disabled={!isEditable}
                                            />
                                            <label htmlFor="lcClientNumberEdit">Client Number *</label>
                                        </div>
                                        <div className={`float-input-wrap ${contactName ? 'has-value' : ''}`} style={{ flex: 1 }}>
                                            <input
                                                type="text"
                                                id="lcClientNameEdit"
                                                className={errors.contactName ? 'is-invalid' : ''}
                                                placeholder=" "
                                                value={contactName}
                                                onChange={e => { setContactName(e.target.value); if (e.target.value) setErrors(prev => { const err = { ...prev }; delete err.contactName; return err; }); }}
                                                disabled={!isEditable}
                                            />
                                            <label htmlFor="lcClientNameEdit">Client Name *</label>
                                        </div>
                                        <div className={`float-input-wrap ${prospectAmount ? 'has-value' : ''}`} style={{ flex: 1 }}>
                                            <input
                                                type="number"
                                                id="lcAmountEdit"
                                                placeholder=" "
                                                value={prospectAmount || ''}
                                                onChange={e => setProspectAmount(e.target.value ? Number(e.target.value) : null)}
                                                disabled={!isEditable}
                                                style={{ MozAppearance: 'textfield' }}
                                            />
                                            <label htmlFor="lcAmountEdit">Amount</label>
                                        </div>
                                    </div>

                                    {/* Description — ReactQuill with floating label, exact same as create modal */}
                                    <div
                                        className={`lc-desc-float-wrap mt-4 ${descIsActive ? 'lc-focused' : ''} ${descHasValue ? 'lc-has-value' : ''}`}
                                        onClick={(e) => {
                                            if (!isEditable) return;
                                            const anchor = e.target.closest('a');
                                            if (anchor && anchor.closest('.ql-editor')) {
                                                e.preventDefault();
                                                const url = anchor.getAttribute('href');
                                                setLinkUrl(url);
                                                setShowLinkInput(true);

                                                const q = quillRef.current?.getEditor();
                                                const Quill = ReactQuill.Quill;
                                                const blot = Quill.find(anchor);
                                                if (blot) {
                                                    clickedLinkRef.current = {
                                                        index: q.getIndex(blot),
                                                        length: blot.length()
                                                    };
                                                }
                                            }
                                        }}
                                    >
                                        <ReactQuill
                                            ref={quillRef}
                                            theme="snow"
                                            placeholder=""
                                            value={details}
                                            onChange={setDetails}
                                            onFocus={() => setIsDescFocused(true)}
                                            onBlur={() => setIsDescFocused(false)}
                                            modules={{ toolbar: false }}
                                            style={{ fontSize: '15px' }}
                                            readOnly={!isEditable}
                                        />
                                        <span className="lc-desc-icon" style={{ display:'inline-block', width:'18px', height:'18px', flexShrink:0, backgroundColor: '#a0a0a0', mask:"url('/assets/images/descriptionmodal.svg') no-repeat center / contain", WebkitMask:"url('/assets/images/descriptionmodal.svg') no-repeat center / contain" }} />
                                        <label>Description</label>

                                        {/* Toolbar — same as create modal */}
                                        <div className="lc-desc-toolbar" onMouseDown={e => e.preventDefault()}>
                                            <button type="button" className="lc-toolbar-btn" onClick={() => { const q = quillRef.current?.getEditor(); if (q) { const f = q.getFormat(); q.format('bold', !f.bold); } }}>
                                                <i className="uil uil-bold" />
                                            </button>
                                            <button type="button" className="lc-toolbar-btn" onClick={() => { const q = quillRef.current?.getEditor(); if (q) { const f = q.getFormat(); q.format('italic', !f.italic); } }}>
                                                <i className="uil uil-italic" />
                                            </button>
                                            <button type="button" className="lc-toolbar-btn" onClick={() => { const q = quillRef.current?.getEditor(); if (q) { const f = q.getFormat(); q.format('underline', !f.underline); } }}>
                                                <i className="uil uil-underline" />
                                            </button>
                                            <div className="position-relative">
                                                <button type="button" className="lc-toolbar-btn" onClick={() => setShowEmojiPicker(v => !v)}>
                                                    <i className="uil uil-smile" />
                                                </button>
                                                {showEmojiPicker && (
                                                    <div className="position-absolute" style={{ top: '40px', left: '0', zIndex: 10000 }} onMouseDown={e => e.stopPropagation()}>
                                                        <EmojiPicker onEmojiClick={emojiData => {
                                                            const q = quillRef.current?.getEditor();
                                                            if (q) {
                                                                const range = q.getSelection();
                                                                if (range) {
                                                                    q.insertText(range.index, emojiData.emoji);
                                                                } else {
                                                                    q.insertText(q.getLength(), emojiData.emoji);
                                                                }
                                                            }
                                                            setShowEmojiPicker(false);
                                                        }} width={300} height={400} />
                                                    </div>
                                                )}
                                            </div>
                                            <div className="position-relative">
                                                <button type="button" className="lc-toolbar-btn" onClick={() => {
                                                    const q = quillRef.current?.getEditor();
                                                    if (q) {
                                                        const f = q.getFormat();
                                                        if (f.link) {
                                                            setLinkUrl(f.link);
                                                            const range = q.getSelection();
                                                            if (range) {
                                                                const [leaf] = q.getLeaf(range.index);
                                                                let blot = leaf;
                                                                const Quill = ReactQuill.Quill;
                                                                while (blot && blot.statics.blotName !== 'link' && blot !== q.scroll) {
                                                                    blot = blot.parent;
                                                                }
                                                                if (blot && blot.statics.blotName === 'link') {
                                                                    clickedLinkRef.current = {
                                                                        index: q.getIndex(blot),
                                                                        length: blot.length()
                                                                    };
                                                                } else {
                                                                    clickedLinkRef.current = { index: null, length: null };
                                                                }
                                                            }
                                                        } else {
                                                            setLinkUrl("");
                                                            clickedLinkRef.current = { index: null, length: null };
                                                        }
                                                    }
                                                    setShowLinkInput(v => !v);
                                                }}>
                                                    <i className="uil uil-link" />
                                                </button>
                                                {showLinkInput && (
                                                    <div className="position-absolute lc-link-popover" onMouseDown={e => e.stopPropagation()}>
                                                        <div className="d-flex gap-2 align-items-center">
                                                            <input type="text" className="form-control" placeholder="Paste or type a link..." value={linkUrl} onChange={e => setLinkUrl(e.target.value)}
                                                                onKeyDown={e => {
                                                                    if (e.key === 'Enter') {
                                                                        const q = quillRef.current?.getEditor();
                                                                        if (q) {
                                                                            const { index, length } = clickedLinkRef.current;
                                                                            if (index !== null && length !== null) {
                                                                                q.formatText(index, length, 'link', linkUrl);
                                                                            } else {
                                                                                q.format('link', linkUrl);
                                                                            }
                                                                        }
                                                                        setShowLinkInput(false);
                                                                        setLinkUrl('');
                                                                        clickedLinkRef.current = { index: null, length: null };
                                                                    }
                                                                }} />
                                                            {linkUrl && (
                                                                <a
                                                                    href={linkUrl.startsWith('http') ? linkUrl : `https://${linkUrl}`}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    className="lc-toolbar-btn d-flex align-items-center justify-content-center"
                                                                    style={{ padding: '4px 8px', borderRadius: '6px', border: '1.5px solid #1D1D1D', color: '#1D1D1D', textDecoration: 'none', background: '#fff', width: '32px', height: '32px' }}
                                                                    title="Open link in new tab"
                                                                >
                                                                    <i className="uil uil-external-link-alt" style={{ fontSize: '18px' }} />
                                                                </a>
                                                            )}
                                                            {linkUrl && (
                                                                <button
                                                                    type="button"
                                                                    className="lc-toolbar-btn d-flex align-items-center justify-content-center"
                                                                    style={{ padding: '4px 8px', borderRadius: '6px', border: '1.5px solid #ff4d4f', color: '#ff4d4f', background: '#fff', width: '32px', height: '32px' }}
                                                                    title="Remove link"
                                                                    onClick={() => {
                                                                        const q = quillRef.current?.getEditor();
                                                                        if (q) {
                                                                            const { index, length } = clickedLinkRef.current;
                                                                            if (index !== null && length !== null) {
                                                                                q.formatText(index, length, 'link', false);
                                                                            } else {
                                                                                q.format('link', false);
                                                                            }
                                                                        }
                                                                        setShowLinkInput(false);
                                                                        setLinkUrl("");
                                                                        clickedLinkRef.current = { index: null, length: null };
                                                                    }}
                                                                >
                                                                    <i className="uil uil-link-broken" style={{ fontSize: '18px' }} />
                                                                </button>
                                                            )}
                                                            <button type="button" className="lc-link-apply-btn" onClick={() => {
                                                                const q = quillRef.current?.getEditor();
                                                                if (q) {
                                                                    const { index, length } = clickedLinkRef.current;
                                                                    if (index !== null && length !== null) {
                                                                        q.formatText(index, length, 'link', linkUrl);
                                                                    } else {
                                                                        q.format('link', linkUrl);
                                                                    }
                                                                }
                                                                setShowLinkInput(false);
                                                                setLinkUrl('');
                                                                clickedLinkRef.current = { index: null, length: null };
                                                            }}>Apply</button>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                            <button type="button" className="lc-toolbar-btn" onClick={() => { const q = quillRef.current?.getEditor(); if (q) { const f = q.getFormat(); q.format('list', f.list === 'bullet' ? false : 'bullet'); } }}>
                                                <i className="uil uil-list-ul" />
                                            </button>
                                        </div>
                                    </div>

                                </>
                            )}
                        </div>
                        {/* Update button fixed at bottom of left panel */}
                        {isEditable && !isLoading && (
                            <div style={{ padding: '12px 20px 16px', borderTop: '1px solid #f0f0f0', display: 'flex', justifyContent: 'flex-end', flexShrink: 0 }}>
                                <button className="btn-save-edit" onClick={handleSubmit} disabled={isSubmitting}>
                                    {isSubmitting ? 'Saving...' : 'Update Lead'}
                                </button>
                            </div>
                        )}
                    </div>

                    <div className="edit-right-panel">
                        <div style={{ display: "flex", borderBottom: "1px solid #F0F0F0", marginBottom: 20, flexShrink: 0 }}>
                            {[{ key: "activity", label: "Activity Log" }, { key: "notes", label: "Notes" }].map(tab => (
                                <button
                                    key={tab.key}
                                    onClick={() => setRightTab(tab.key)}
                                    style={{
                                        padding: "10px 24px", border: "none", background: "none", cursor: "pointer", fontSize: 13, fontWeight: rightTab === tab.key ? 700 : 500,
                                        color: rightTab === tab.key ? "#1D1D1D" : "#A0A0A0", borderBottom: rightTab === tab.key ? "2px solid #1D1D1D" : "2px solid transparent", marginBottom: -1, transition: "all 0.2s"
                                    }}
                                >{tab.label}</button>
                            ))}
                        </div>
                        <div className="flex-grow-1" style={{ minHeight: 0, overflowY: 'auto' }}>
                            {rightTab === "notes" ? (
                                <LeadComments leadId={editId} localNotes={localNotes} setLocalNotes={setLocalNotes} mentionUsers={mentionUsers} currentUserId={currentUserId} companyId={companyId} isModal={true} />
                            ) : (
                                <LeadActivityLog leadId={editId} companyId={companyId} />
                            )}
                        </div>
                    </div>
                </div>

            {/* Mark as Lost Modal */}
            {lostModal && (
                <div
                    style={{ position: "fixed", inset: 0, zIndex: 100010, background: "rgba(0,0,0,0.45)", display: "flex", alignItems: "center", justifyContent: "center" }}
                    onClick={e => { if (e.target === e.currentTarget) setLostModal(false); }}
                >
                    <div style={{ background: "#fff", borderRadius: "12px", width: 440, maxWidth: "95vw", padding: "24px", boxShadow: "0 8px 40px rgba(0,0,0,0.2)" }} onClick={e => e.stopPropagation()}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
                            <h5 style={{ margin: 0, fontSize: "17px", fontWeight: "600", color: "#ef4444" }}>Mark as Lost</h5>
                            <button type="button" className="btn-close" onClick={() => setLostModal(false)} />
                        </div>
                        <div className="mb-3">
                            <div className={`float-select-wrap ${lostReason ? "has-value" : ""}`}>
                                <label>Reason *</label>
                                <AntSelect
                                    placeholder=""
                                    style={{ width: "100%" }}
                                    value={lostReason}
                                    onChange={val => setLostReason(val)}
                                    getPopupContainer={trigger => trigger.parentNode}
                                >
                                    {LOST_REASONS.map(r => <Option key={r.value} value={r.value}>{r.label}</Option>)}
                                </AntSelect>
                            </div>
                        </div>
                        <div className="mb-4">
                            <div className={`float-input-wrap ${lostNotes ? "has-value" : ""}`}>
                                <textarea
                                    className="form-control"
                                    rows={3}
                                    value={lostNotes}
                                    onChange={e => setLostNotes(e.target.value)}
                                    placeholder=" "
                                    style={{ resize: "none" }}
                                />
                                <label>Notes</label>
                            </div>
                        </div>
                        <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                            <button type="button" className="btn btn-light" style={{ borderRadius: "6px", fontSize: "13px" }} onClick={() => setLostModal(false)}>Cancel</button>
                            <button type="button" className="btn btn-danger" style={{ borderRadius: "6px", fontSize: "13px" }} onClick={handleLostConfirm}>Mark Lost</button>
                        </div>
                    </div>
                </div>
            )}

            {/* Mark as Won Modal */}
            {wonModal && (
                <div
                    style={{ position: "fixed", inset: 0, zIndex: 100010, background: "rgba(0,0,0,0.45)", display: "flex", alignItems: "center", justifyContent: "center" }}
                    onClick={e => { if (e.target === e.currentTarget) setWonModal(false); }}
                >
                    <div style={{ background: "#fff", borderRadius: "12px", width: 440, maxWidth: "95vw", padding: "24px", boxShadow: "0 8px 40px rgba(0,0,0,0.2)" }} onClick={e => e.stopPropagation()}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
                            <h5 style={{ margin: 0, fontSize: "17px", fontWeight: "600", color: "#10b981" }}>Mark as Won</h5>
                            <button type="button" className="btn-close" onClick={() => setWonModal(false)} />
                        </div>
                        <div className="mb-3">
                            <div className={`float-input-wrap ${wonAmount !== null && wonAmount !== "" ? "has-value" : ""}`}>
                                <input
                                    type="number"
                                    className="form-control"
                                    placeholder=" "
                                    value={wonAmount ?? ""}
                                    onChange={e => setWonAmount(e.target.value ? Number(e.target.value) : null)}
                                />
                                <label>Amount</label>
                            </div>
                        </div>
                        <div className="mb-4">
                            <div className={`float-input-wrap ${wonReference ? "has-value" : ""}`}>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder=" "
                                    value={wonReference}
                                    onChange={e => setWonReference(e.target.value)}
                                />
                                <label>Reference</label>
                            </div>
                        </div>
                        <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                            <button type="button" className="btn btn-light" style={{ borderRadius: "6px", fontSize: "13px" }} onClick={() => setWonModal(false)}>Cancel</button>
                            <button type="button" className="btn" style={{ borderRadius: "6px", fontSize: "13px", background: "#10b981", color: "#fff", border: "none" }} onClick={handleWonConfirm}>Mark Won</button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default CreateCrmLead;
